import _ from "lodash";

import { Badge2 } from "@/ui2/atoms/Badge";

export function getBadges(note) {
  let badges = [];

  if (!note.is_billable) {
    badges.push(
      <li className="tw:contents" key="badge-non-billable">
        <Badge2 size="xs" variant="navy">
          NON-BILLABLE
        </Badge2>
      </li>,
    );
  }

  if (_.get(note, "content.patient_no_show")) {
    badges.push(
      <li className="tw:contents" key="badge-patient-no-show-1">
        <Badge2 size="xs" variant="warning">
          PATIENT-NO-SHOW
        </Badge2>
      </li>,
    );
  }

  if (
    note.note_type === "Initial Clinical Assessment" &&
    note.content?.patient_no_show_array &&
    !note.completed_date_time
  ) {
    badges.push(
      <li className="tw:contents" key="badge-patient-no-show-2">
        <Badge2 size="xs" variant="warning">
          PATIENT-NO-SHOW
        </Badge2>
      </li>,
    );
  }

  if (note?.call_state === "cancelled") {
    badges.push(
      <li className="tw:contents" key="badge-session-cancelled">
        <Badge2 size="xs" variant="error">
          SESSION CANCELLED
        </Badge2>
      </li>,
    );
  }

  return badges;
}
